/* hc-comparison.js - script de sections/product-comparison.liquid, externalise le 19-08-2026 (defer). */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.comparison-section').forEach(function (section) {
    section.querySelectorAll('.product-header.highlighted').forEach(function (header) {
      var columnIndex = header.getAttribute('data-column');
      if (!columnIndex) return;
      section.querySelectorAll('.value-cell[data-column="' + columnIndex + '"]').forEach(function (cell) {
        cell.classList.add('highlighted');
      });
    });
  });
});